export class ConfigureBulkEmailDto {

	constructor(public GroupTableId: number,
				public GroupId: number,
				public MailFieldId: number,
				public TemplateId: number,
				public RequestTemplateId: number,
				public TemplateEntityId: number) {
	}
}